import React from 'react';
import styled from 'styled-components';

import { zIndex } from 'constants/styles/z-index';
import closeImage from '../../../images/svg/close.svg';
import burgerImage from '../../../images/svg/burger.svg';

const SWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${zIndex.burger};
    cursor: pointer;
    flex-shrink: 0;
`;

interface Props {
    onClick: () => void;
    isOpen: boolean;
}

export const Burger = ({ onClick, isOpen }: Props) => {
    return (
        <SWrapper onClick={onClick}>
            {isOpen ? (
                <img src={closeImage} alt="Mobile menu close icon" />
            ) : (
                <img src={burgerImage} alt="Mobile menu open icon" />
            )}
        </SWrapper>
    );
};
